// extracted by mini-css-extract-plugin
export default {"reactswitchcheckbox":"styles_reactswitchcheckbox__Crjnb","reactswitchlabel":"styles_reactswitchlabel__B7y97","reactswitchbutton":"styles_reactswitchbutton__fC2z0"};